/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'backbone',
        'underscore',
        'assets/js/modules/widgets/mailingLists/model/mailingListsWidgetModel',
        'assets/js/modules/widgets/mailingLists/model/mailingListModel',
        'assets/js/modules/widgets/mailingLists/mailingListItemCollection',
        'assets/js/modules/api/mailingLists',
        'assets/js/modules/widgets/mailingLists/mailingListParser',
        'assets/js/modules/utils'
    ],
    function(
        $,
        backbone,
        _,
        MailingListsWidgetModel,
        MailingListModel,
        MailingListItemCollection,
        mailingListsApi,
        MailingListParser,
        utils
    ) {
        var ITEMS_MIN_LENGTH = MailingListsWidgetModel.MIN_LIST_ITEMS_LENGTH;
        var ITEMS_GET_LIMIT = 1000;
        var ITEMS_LARGE_LENGTH = 5000;

        /**
         * @param {MailingListsWidgetModel} model
         */
        var MailingListsWidget = function(model) {
            var _this = this,
                list;

            _.extend(this, backbone.Events);

            this.model = model;

            this.listenTo(this.model, {
                'list:choose': this.changeList,
                'list:addCurrentResident': this.setAddCurrentResident,
                'list:save': this.save,
                'list:uploadPrepare': this.uploadPrepare,
                'list:upload': this.uploadList,
                'list:create': this.createList,
                'list:nameCreated': this.saveNewList,
                'list:columnsMatch': this.createListFromUpload,
                'list:remove': this.removeList,
                'item:addPrepare': this.validateItems,
                'item:select': this.selectItem,
                'items:change': this.onItemsChange,
                'items:load': this.loadItems,
                'items:selectAll': this.selectItems,
                'items:remove': this.removeItemsPrepare,
                'items:restore': this.restoreItems,
                'undo:enabled': function() {
                    _this.model.set('unSavedChanges', true);
                },
                'undo:disabled': function() {
                    _this.model.set('unSavedChanges', false);
                }
            });

            this.getCustomerListsOperation = mailingListsApi.getMyLists().on('success', function(response) {
                _this.model.get('lists').reset();
                _this.fillLists(response._embedded.items);
                if (response.page * response.limit < response.total) {
                    this.start(_.defaults({ page: response.page + 1 }, this.getObject()));
                    return;
                }
                _this.getChosenList();
            });

            this.getItemsOperation = mailingListsApi
                .getItemsByToken()
                .on('success', function(data) {
                    list = _this.model.get('lists').findWhere({ token: data.token });
                    list.set('records', data.items.total);
                    list.set('currentRecords', data.items.total);
                    _this.addDummyItemsAsync(list, list.get('records')).done(function() {
                        _this.fillItems(list, data.items._embedded.items, data.items.page);
                        _this.model.trigger('items:loaded');
                        _this.model.trigger('list:currentRecords:changed');
                    });
                })
                .on('error', function(data) {
                    list = _this.model.get('lists').findWhere({ token: data.token });
                    if (list) {
                        list.set('pagesLoaded', _.without(list.get('pagesLoaded'), data.page));
                    }
                })
                .on('finished', function() {
                    _this.stopLoading();
                });

            this.parser = new MailingListParser().on({
                fileUploaded: function(results, columns) {
                    _this.model.set('uploadListLoading', false);
                    _this.model.trigger('list:uploaded', results, columns);
                },
                success: function(list) {
                    _this.model.set('uploadListLoading', false);
                    _this.addListFromUpload(list);
                },
                info: function(message) {
                    alert(message);
                },
                error: function(message) {
                    _this.model.set('uploadListLoading', false);
                    _this.model.trigger('parser:error');
                    alert(message);
                }
            });

            if (this.model.get('user').loggedIn) {
                this.getCustomerListsOperation.start({ user: _this.model.get('user') });
            } else {
                this.getChosenList();
            }
        };

        MailingListsWidget.prototype = {
            getChosenList: function() {
                var _this = this;
                var lists = _this.model.get('lists');
                var listTokenChosen = this.model.get('listTokenChosen');
                if (listTokenChosen && !lists.findWhere({ token: listTokenChosen })) {
                    var cartToken = _this.model.get('cartToken');
                    var cartItemId = _this.model.get('cartItemId');
                    if (cartToken && cartItemId) {
                        mailingListsApi
                            .getListForCartItem(cartToken, cartItemId)
                            .on('success', function(data) {
                                var list = new MailingListModel().fromDTO(data);
                                list.set('deleted', true);
                                lists.add(list);
                                _this.setCurrentList();
                            })
                            .start();
                    } else {
                        mailingListsApi
                            .getList()
                            .on('success', function(data) {
                                var list = new MailingListModel().fromDTO(data);
                                lists.add(list);
                                _this.setCurrentList();
                            })
                            .start({
                                token: _this.model.get('listTokenChosen')
                            });
                    }
                } else {
                    this.setCurrentList();
                }
            },

            /**
             * @param {Object} listsDTO
             */
            fillLists: function(listsDTO) {
                var _this = this;
                _.each(listsDTO, function(listDTO) {
                    var model = new MailingListModel().fromDTO(listDTO);
                    _this.model.get('lists').add(model);
                });
            },

            /**
             * @param {MailingListModel} list
             * @param {Object} itemsDTO
             * @param {number} page
             */
            fillItems: function(list, itemsDTO, page) {
                var items = list.get('itemsCollection').getItems();
                var orderId = (page - 1) * ITEMS_GET_LIMIT;
                _.each(itemsDTO, function(itemDTO) {
                    var item = items[orderId];
                    MailingListItemCollection.itemFromDTO(item, itemDTO);
                    item['loaded'] = true;
                    orderId++;
                });
            },

            setCurrentList: function() {
                var _this = this;
                var lists = this.model.get('lists');
                var list = this.model.get('currentList');
                var listTokenChosen = this.model.get('listTokenChosen');

                if (lists.length) {
                    list = lists.first();
                    if (listTokenChosen) {
                        var listChosen = lists.findWhere({ token: listTokenChosen });
                        if (listChosen) {
                            list = listChosen;
                        }
                    }
                    this.model.set('currentList', list);
                } else {
                    lists.add(list);
                }

                this.model.trigger('lists:loaded');

                this.addDummyItemsAsync(list, list.get('records')).done(function() {
                    _this.getItemsByPage(1);
                });
            },

            /**
             * @param {string} cid
             */
            changeList: function(cid) {
                var _this = this;
                var list = this.model.get('lists').get(cid);

                if (!this.confirmChangesLoss()) {
                    this.model.trigger('currentList:rollBack');
                    return;
                }

                this.clearList(list);

                this.model.set('currentList', list);
                if (list.get('records') >= ITEMS_LARGE_LENGTH) {
                    this.startLoading();
                }

                this.addDummyItemsAsync(list, list.get('records')).done(function() {
                    _this.getItemsByPage(1);
                });
            },

            /**
             * @param list - MailingListModel
             */
            clearList: function(list) {
                list.clearList();
                this.model.set('allItemsSelected', false);
            },

            confirmChangesLoss: function() {
                var list = this.model.get('currentList');
                if (this.model.get('unSavedChanges')) {
                    if (!confirm('You have unsaved changes in mailing list "' + list.get('name') + '". They will be lost.')) {
                        return false;
                    }
                }
                this.model.set('unSavedChanges', false);

                return true;
            },

            /**
             * @param {number} fromOrderId
             * @param {number} toOrderId
             */
            loadItems: function(fromOrderId, toOrderId) {
                var page = Math.ceil(fromOrderId / ITEMS_GET_LIMIT);
                page = page === 0 ? 1 : page;
                this.getItemsByPage(page);

                var nextPage = Math.ceil(toOrderId / ITEMS_GET_LIMIT);
                if (nextPage !== page) {
                    this.getItemsByPage(nextPage);
                }
            },

            /**
             * @param {number} page
             */
            getItemsByPage: function(page) {
                var list = this.model.get('currentList');
                if (list.get('token') && list.get('records')) {
                    if (_.indexOf(list.get('pagesLoaded'), page) === -1) {
                        this.startLoading();
                        list.get('pagesLoaded').push(page);
                        var getAttached = this.model.get('listTokenChosen') === list.get('token');
                        this.getItemsOperation.start({
                            limit: ITEMS_GET_LIMIT,
                            token: list.get('token'),
                            cartToken: getAttached ? this.model.get('cartToken') : null,
                            cartItemId: getAttached ? this.model.get('cartItemId') : null,
                            page: page
                        });
                        return;
                    }
                } else {
                    this.stopLoading();
                    list.get('itemsCollection').setLoaded(true);
                }
                this.model.trigger('items:loaded', list);
            },

            /**
             * @param {boolean} isSelected
             */
            selectItems: function(isSelected) {
                var _this = this;
                var itemsCollection = this.model.get('currentList').get('itemsCollection');
                if (itemsCollection.getLength() > ITEMS_LARGE_LENGTH) {
                    this.startLoading();
                }
                setTimeout(function() {
                    itemsCollection.getItems().forEach(function(item) {
                        item['selected'] = isSelected;
                    });
                    _this.stopLoading();
                    _this.model.set('allItemsSelected', isSelected);
                    _this.model.trigger('items:selected');
                }, 5);
            },

            /**
             * @param {Object} item
             * @param {boolean} isSelected
             */
            selectItem: function(item, isSelected) {
                item['selected'] = isSelected;
                this.updateAllItemsSelected();
                this.model.trigger('item:selected');
            },

            /**
             * @param {MailingListItemCollection} itemsCollection
             * @param {number[]} indexes
             */
            removeItemsPrepare: function(itemsCollection, indexes) {
                var _this = this;
                var list = this.model.get('currentList');
                indexes = indexes || [];

                if (itemsCollection.getLength() > ITEMS_LARGE_LENGTH) {
                    this.startLoading();
                }

                if (indexes.length) {
                    this.removeItems(itemsCollection, indexes);
                } else {
                    utils
                        .iterateAsync(
                            0,
                            itemsCollection.getLength(),
                            function(index) {
                                var item = itemsCollection.at(index);
                                indexes.push(list.get('itemsCollection').indexOf(item));
                            },
                            700
                        )
                        .then(function() {
                            _this.removeItems(itemsCollection, indexes);
                        });
                }
            },

            /**
             * @param {MailingListItemCollection} itemsCollection
             * @param {number[]} indexes
             */
            removeItems: function(itemsCollection, indexes) {
                var _this = this,
                    itemsCount;
                var list = this.model.get('currentList');
                var items = list.get('itemsCollection').getItems();

                this.model.trigger('items:beforeRemove', itemsCollection, indexes);

                var removePartLength = 500;
                var removeAsync = utils.iterateAsync(
                    0,
                    itemsCollection.getLength(),
                    function(index) {
                        var item = itemsCollection.at(index);
                        var id = item['record'];

                        item['selected'] = false;
                        if (!item['loaded']) {
                            /* User is trying to remove all unloaded items, cause it's impossible to remove part of unloaded items.
                     He wants to keep only loaded items, then.*/
                            list.set('replaceMode', true);
                        }

                        if (id) {
                            list.get('removedItemIds').push(id);
                        }

                        //remove from collection in parts for better productivity
                        index++;
                        var remainder = index % removePartLength;
                        if (remainder === 0 || index === itemsCollection.getLength()) {
                            var startIndex = remainder === 0 ? index - removePartLength : index - remainder;
                            // find all elements for remove
                            var elementsForRemove = itemsCollection.getItems().slice(startIndex, index);

                            elementsForRemove.forEach(function(elementForRemove) {
                                // find indexes for remove
                                var removalIndex = items.indexOf(elementForRemove);
                                items.splice(removalIndex, 1);
                            });
                        }
                    },
                    500
                );

                removeAsync.then(function() {
                    _this.addDummyItemsAsync(list).done(function() {
                        if (list.get('itemsCollection').getLength() <= ITEMS_MIN_LENGTH) {
                            list.get('itemsCollection').setLoaded(true);
                        }
                        if (list.get('replaceMode')) {
                            itemsCount = list.get('itemsCollection').filterNonEmpty().length;
                        } else {
                            itemsCount = list.get('currentRecords') - itemsCollection.filterNonEmpty().length;
                        }
                        list.set('currentRecords', itemsCount);
                        _this.model.trigger('list:currentRecords:changed');

                        _this.model.set('allItemsSelected', false);
                        _this.stopLoading();

                        _this.model.trigger('items:removed');
                    });
                });
            },

            /**
             * @param {MailingListItemCollection} itemsCollection
             * @param {number[]} indexes
             */
            restoreItems: function(itemsCollection, indexes) {
                var _this = this;
                var itemsCount;
                var list = this.model.get('currentList');

                if (itemsCollection.getLength() > ITEMS_LARGE_LENGTH) {
                    this.startLoading();
                }

                var restoreAsync = utils.iterateAsync(
                    0,
                    itemsCollection.getLength(),
                    function(index) {
                        var item = itemsCollection.at(index);
                        var id = item['record'];
                        var collectionIndex = indexes[index];

                        var dummyItem = list.get('itemsCollection').get(item['orderId']);
                        if (dummyItem) {
                            _.extendOwn(dummyItem, {
                                record: item['record'],
                                title: item['title'],
                                firstName: item['firstName'],
                                middleInitial: item['middleInitial'],
                                lastName: item['lastName'],
                                company: item['company'],
                                address: item['address'],
                                address2: item['address2'],
                                city: item['city'],
                                state: item['state'],
                                postalCode: item['postalCode']
                            });
                        } else {
                            list
                                .get('itemsCollection')
                                .getItems()
                                .splice(collectionIndex, 0, item);
                        }
                        if (!item['loaded']) {
                            /**
                             * User is trying to restore all unloaded items,
                             * cause it's impossible to restore part of unloaded items.
                             * Change mode.
                             */
                            list.set('replaceMode', false);
                        }
                        if (id) {
                            var idIndex = _.indexOf(list.get('removedItemIds'), id);
                            list.get('removedItemIds').splice(idIndex, 1);
                        }
                    },
                    500
                );

                restoreAsync.then(function() {
                    itemsCount =
                        list.get('currentRecords') +
                        itemsCollection.getLength() -
                        itemsCollection.filterEmpty(false, { loaded: true }).length;
                    list.set('currentRecords', itemsCount);

                    _this.stopLoading();

                    _this.model.trigger('list:currentRecords:changed');
                    _this.model.trigger('items:restored');
                });
            },

            /**
             * @param {MailingListItemCollection} itemsCollection
             * @param {boolean[]} wereEmpty
             */
            onItemsChange: function(itemsCollection, wereEmpty) {
                var _this = this;
                var list = this.model.get('currentList');

                itemsCollection.getItems().forEach(function(item, index) {
                    var id = item['record'];
                    if (id && !_.contains(list.get('editedItemIds'), id) && !list.get('replaceMode')) {
                        list.get('editedItemIds').push(id);
                    }

                    if (MailingListItemCollection.isEmptyItem(item) && !wereEmpty[index]) {
                        list.set('currentRecords', list.get('currentRecords') - 1);
                        _this.model.trigger('list:currentRecords:changed');
                        wereEmpty[index] = true;
                    }
                    if (!MailingListItemCollection.isEmptyItem(item) && wereEmpty[index]) {
                        list.set('currentRecords', list.get('currentRecords') + 1);
                        _this.model.trigger('list:currentRecords:changed');
                        wereEmpty[index] = false;
                    }
                });
            },

            updateAllItemsSelected: function() {
                var itemsCollection = this.model.get('currentList').get('itemsCollection');
                if (!itemsCollection.findWhere({ selected: false })) {
                    this.model.set('allItemsSelected', true);
                } else {
                    this.model.set('allItemsSelected', false);
                }
            },

            /**
             * @param {callback} saveCallback
             */
            save: function(saveCallback) {
                this.model.set('saveCallback', saveCallback);
                var list = this.model.get('currentList');

                if (list.get('token')) {
                    this.saveEditedList();
                } else {
                    if (this.model.get('user').loggedIn) {
                        this.model.trigger('list:nameCreate');
                    } else {
                        this.saveNewList();
                    }
                }
            },

            createList: function() {
                if (this.confirmChangesLoss()) {
                    var lists = this.model.get('lists');
                    var list = new MailingListModel();
                    list.set('name', this.generateListName(lists));
                    lists.add(list);
                    this.model.trigger('lists:added', list);
                    this.clearList(this.model.get('currentList'));
                    this.model.set('currentList', list);
                }
            },

            uploadPrepare: function() {
                if (this.confirmChangesLoss()) {
                    this.model.trigger('list:uploadPrepared');
                }
            },

            /**
             * @param {File} file
             */
            uploadList: function(file) {
                var errors = this.parser.validateFile(file).errors;
                if (errors.length) {
                    alert(errors[0]);
                    return false;
                }
                this.model.trigger('list:parsingStarted');
                this.model.set('uploadListLoading', true);
                this.parser.parseFile(file);
            },

            /**
             * @param {string[]} columns
             */
            createListFromUpload: function(columns) {
                var _this = this;
                var errors = this.parser.validateColumns(columns).errors;
                if (errors.length) {
                    alert(errors[0]);
                    return false;
                }
                this.model.set('uploadListLoading', true);
                //delay to let DOM apply visual changes such as loading bar
                setTimeout(function() {
                    _this.parser.fillMailingList(columns);
                }, 10);
            },

            /**
             * @param {string} cid
             */
            removeList: function(cid) {
                var _this = this;
                var lists = this.model.get('lists');
                var listsCount = lists.length;
                var list = lists.get(cid);
                var listToken = list.get('token');

                // remove unsaved lists
                if (listToken === null) {
                    lists.remove(cid);
                    _this.model.trigger('list:choose', lists.first());
                    _this.model.trigger('lists:loaded');
                    // remove saved lists
                } else {
                    this.startLoading();
                    mailingListsApi
                        .deleteList()
                        .on('success', function() {
                            lists.remove(cid);
                            if (listsCount === 1) {
                                _this.model.trigger('list:create');
                                _this.stopLoading();
                            } else {
                                _this.model.trigger('list:choose', lists.first().cid);
                            }
                            _this.model.trigger('lists:loaded');
                        })
                        .start({
                            token: listToken
                        });
                }
            },

            /**
             * @param {MailingListModel} list
             */
            addListFromUpload: function(list) {
                var lists = this.model.get('lists');
                list.set('name', this.generateListName(lists));
                lists.add(list);
                this.model.trigger('lists:added', list);
                this.clearList(this.model.get('currentList'));
                this.model.set('currentList', list);
                this.model.set('unSavedChanges', true);
            },

            /**
             * @param {MailingListItemCollection} lists
             */
            generateListName: function(lists) {
                var textPrefix = 'List ';
                var maxNumber = 0;
                var generatedLists = lists.filter(function(list) {
                    return /^List \d{2,}$/.test(list.get('name'));
                });
                if (generatedLists.length) {
                    maxNumber = _.max(
                        _.map(generatedLists, function(generatedList) {
                            var number = generatedList.get('name').slice(textPrefix.length);
                            return parseInt(number);
                        })
                    );
                }
                maxNumber++;
                return textPrefix + (maxNumber < 10 ? '0' + maxNumber : maxNumber);
            },

            validateItems: function() {
                if (
                    this.model
                        .get('currentList')
                        .get('itemsCollection')
                        .getLength() === MailingListModel.MAX_ITEMS_LENGTH
                ) {
                    alert("You can't have more than " + MailingListModel.MAX_ITEMS_LENGTH + ' items.');
                    return false;
                }
                this.model.trigger('item:addPrepared');
            },

            /**
             * @param {string} listName
             */
            saveNewList: function(listName) {
                var _this = this;
                var list = this.model.get('currentList');

                if (listName) {
                    list.set('name', listName);
                }

                var lists = this.model.get('lists');
                if (lists.where({ name: listName }).length > 1) {
                    _this.model.trigger('list:nameCreate');
                    alert('A Mailing List with this name already exists. Please choose a different name.');

                    return false;
                }

                this.startLoading();

                var itemsCollectionToSend = new MailingListItemCollection(list.get('itemsCollection').filterNonEmpty(true));

                var createOperation = mailingListsApi.createList();
                this.setHandlersOnSaveOperation(createOperation, list);

                createOperation.start(
                    _.extend(list.toDTO(), {
                        items: itemsCollectionToSend.toDTO(),
                        user: _this.model.get('user')
                    })
                );
            },

            saveEditedList: function() {
                var _this = this,
                    operation,
                    itemsToSend;
                var list = this.model.get('currentList');

                this.startLoading();

                if (list.get('replaceMode')) {
                    operation = mailingListsApi.replaceList();
                    itemsToSend = this.getItemsToReplace();
                } else {
                    operation = mailingListsApi.updateList();
                    itemsToSend = this.getItemsToUpdate();
                }

                this.setHandlersOnSaveOperation(operation, list);

                operation.start(
                    _.extend(list.toDTO(), {
                        items: itemsToSend.toDTO(),
                        user: _this.model.get('user'),
                        cartToken: _this.model.get('cartToken'),
                        cartItemId: _this.model.get('cartItemId')
                    })
                );
            },

            getItemsToUpdate: function() {
                var list = this.model.get('currentList');
                var itemsCollection = list.get('itemsCollection');
                var itemsCollectionToSend = new MailingListItemCollection([]);

                // add edited items
                _.each(list.get('editedItemIds'), function(id) {
                    var item = itemsCollection.findWhere({ record: id });
                    if (item) {
                        itemsCollectionToSend.add(item);
                    }
                });
                // add removed items
                _.each(list.get('removedItemIds'), function(id) {
                    var item = MailingListItemCollection.getDefaultItem({
                        record: id
                    });
                    itemsCollectionToSend.add(item);
                });
                // add new items
                var newItems = itemsCollection.filterNonEmpty(false, { record: null });
                itemsCollectionToSend.addAll(newItems);

                return itemsCollectionToSend;
            },

            getItemsToReplace: function() {
                var items = this.model
                    .get('currentList')
                    .get('itemsCollection')
                    .filterNonEmpty(false, { loaded: true });

                return new MailingListItemCollection(items);
            },

            /**
             * @param {Operation} operation
             * @param {MailingListModel} list
             */
            setHandlersOnSaveOperation: function(operation, list) {
                var _this = this;
                var saveCallback = this.model.get('saveCallback');

                operation.on({
                    success: function(data) {
                        list.fromDTO(data);
                        _this.model.trigger('list:reload');

                        if (saveCallback) {
                            _this.stopLoading();
                            saveCallback();
                        } else {
                            _this.clearList(list);
                            _this.addDummyItemsAsync(list, list.get('records')).done(function() {
                                _this.getItemsByPage(1);
                                _this.model.trigger('items:reload');
                            });
                        }
                    },
                    error: function(message) {
                        _this.stopLoading();
                        alert(message);
                    }
                });
            },

            /**
             * @param {boolean} addCurrentResident
             */
            setAddCurrentResident: function(addCurrentResident) {
                this.model.get('currentList').set('addCurrentResident', addCurrentResident);
                this.model.set('unSavedChanges', true);
                this.model.trigger('list:addCurrentResident:changed');
            },

            getItemsCount: function() {
                return this.model.get('currentList').get('currentRecords');
            },

            getCurrentListToken: function() {
                return this.model.get('currentList').get('token');
            },

            startLoading: function() {
                this.model.set('listLoading', true);
                this.trigger('startLoading');
            },

            stopLoading: function() {
                this.model.set('listLoading', false);
                this.trigger('stopLoading');
            },

            /**
             * @param {MailingListModel} list
             * @param {number} length
             * @returns {Object}
             */
            addDummyItemsAsync: function(list, length) {
                var d = $.Deferred();
                var itemsCollection = list.get('itemsCollection');

                length = length || ITEMS_MIN_LENGTH;
                length = length < ITEMS_MIN_LENGTH ? ITEMS_MIN_LENGTH : length;
                if (itemsCollection.getLength() < length) {
                    itemsCollection.addDummiesAsync(length).done(function() {
                        d.resolve();
                    });
                } else {
                    d.resolve();
                }
                return d.promise();
            }
        };

        return MailingListsWidget;
    }
);
